// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/StateView.sol/StateView.json

export const STATE_VIEW_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_poolManager",
        "type": "address",
        "internalType": "contract IPoolManager"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "getFeeGrowthGlobals",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      }
    ],
    "outputs": [
      {
        "name": "feeGrowthGlobal0",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthGlobal1",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getFeeGrowthInside",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "tickLower",
        "type": "int24",
        "internalType": "int24"
      },
      {
        "name": "tickUpper",
        "type": "int24",
        "internalType": "int24"
      }
    ],
    "outputs": [
      {
        "name": "feeGrowthInside0X128",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthInside1X128",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getLiquidity",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      }
    ],
    "outputs": [
      {
        "name": "liquidity",
        "type": "uint128",
        "internalType": "uint128"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getPositionInfo",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "positionId",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "liquidity",
        "type": "uint128",
        "internalType": "uint128"
      },
      {
        "name": "feeGrowthInside0LastX128",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthInside1LastX128",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getPositionInfo",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "owner",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "tickLower",
        "type": "int24",
        "internalType": "int24"
      },
      {
        "name": "tickUpper",
        "type": "int24",
        "internalType": "int24"
      },
      {
        "name": "salt",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "liquidity",
        "type": "uint128",
        "internalType": "uint128"
      },
      {
        "name": "feeGrowthInside0LastX128",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthInside1LastX128",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getPositionLiquidity",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "positionId",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "liquidity",
        "type": "uint128",
        "internalType": "uint128"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getSlot0",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      }
    ],
    "outputs": [
      {
        "name": "sqrtPriceX96",
        "type": "uint160",
        "internalType": "uint160"
      },
      {
        "name": "tick",
        "type": "int24",
        "internalType": "int24"
      },
      {
        "name": "protocolFee",
        "type": "uint24",
        "internalType": "uint24"
      },
      {
        "name": "lpFee",
        "type": "uint24",
        "internalType": "uint24"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTickBitmap",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "tick",
        "type": "int16",
        "internalType": "int16"
      }
    ],
    "outputs": [
      {
        "name": "tickBitmap",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTickFeeGrowthOutside",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "tick",
        "type": "int24",
        "internalType": "int24"
      }
    ],
    "outputs": [
      {
        "name": "feeGrowthOutside0X128",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthOutside1X128",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTickInfo",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "tick",
        "type": "int24",
        "internalType": "int24"
      }
    ],
    "outputs": [
      {
        "name": "liquidityGross",
        "type": "uint128",
        "internalType": "uint128"
      },
      {
        "name": "liquidityNet",
        "type": "int128",
        "internalType": "int128"
      },
      {
        "name": "feeGrowthOutside0X128",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "feeGrowthOutside1X128",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTickLiquidity",
    "inputs": [
      {
        "name": "poolId",
        "type": "bytes32",
        "internalType": "PoolId"
      },
      {
        "name": "tick",
        "type": "int24",
        "internalType": "int24"
      }
    ],
    "outputs": [
      {
        "name": "liquidityGross",
        "type": "uint128",
        "internalType": "uint128"
      },
      {
        "name": "liquidityNet",
        "type": "int128",
        "internalType": "int128"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "poolManager",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IPoolManager"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "error",
    "name": "NotPoolManager",
    "inputs": []
  }
] as const;

export const STATE_VIEW_BYTECODE = "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" as const;
